import { useCallback } from "react";

export default function useTextFormatter() {

  // Convert to lowercase
  const toLower = useCallback(
    (value) => (value ? value.toLowerCase() : value),
    []
  );

  // Convert to uppercase
  const toUpper = useCallback(
    (value) => (value ? value.toUpperCase() : value),
    []
  );

  // Convert to camel case
  const toCamel = useCallback((value) => {
    if (!value) return value;

    return value
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }, []);

  // return all formatter functions
  return { toLower, toUpper, toCamel };
}
